import React from 'react'
import type { AppPlatform } from '@/shared/api'
import { Button } from '@/shared/ui'

const PLATFORM_LABELS: Record<AppPlatform, string> = {
  android: 'Android',
  ios: 'iOS',
}

interface ForcedUpdateConfirmModalProps {
  isOpen: boolean
  platform: AppPlatform
  minVersion: string
  onConfirm: () => void | Promise<void>
  onCancel: () => void
  loading: boolean
}

export const ForcedUpdateConfirmModal: React.FC<ForcedUpdateConfirmModalProps> = ({
  isOpen,
  platform,
  minVersion,
  onConfirm,
  onCancel,
  loading,
}) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="forced-update-title"
    >
      <div className="w-full max-w-md rounded-lg bg-white shadow-xl">
        <div className="space-y-4 p-6">
          <h2 id="forced-update-title" className="text-xl font-semibold text-gray-900">
            Обязательное обновление
          </h2>
          <p className="text-sm text-gray-600">
            Включить обязательное обновление для {PLATFORM_LABELS[platform]}? Курьеры с версией
            ниже {minVersion} не смогут работать до обновления.
          </p>
        </div>
        <div className="flex justify-end gap-3 border-t bg-gray-50 p-6">
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            Отмена
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              void onConfirm()
            }}
            isLoading={loading}
          >
            Включить
          </Button>
        </div>
      </div>
    </div>
  )
}
